module.exports = __webpack_public_path__ + "static/2828-4faf967384eddadbba7cf003f9d80ec8.jpg";